<template>
  <Dialogs :dialog="dialog" :handleClose="close">
    <template #content>
      <div class="dialog_content">
        <el-form ref="form" :model="form" :rules="rules" label-width="200px" size="small">
          <el-form-item id="time" label="发布日期" prop="date" class="inlinitem">
            <el-date-picker :disabled="data.title == '详情'" v-model="form.date" type="date" value-format="yyyy-MM-dd"
              style="width: 200px" placeholder="开始日期">
              <!-- :picker-options="pickerOptions3" -->
            </el-date-picker>
          </el-form-item>
          <el-form-item label="人数" prop="peopleNumber">
            <el-input :disabled="data.title == '详情'" style="width:405px;" maxlength="16" v-model="form.peopleNumber"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="费用" prop="cost">
            <el-input :disabled="data.title == '详情'" style="width:405px;" maxlength="16" v-model="form.cost"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="次数" prop="timeNumber">
            <el-input :disabled="data.title == '详情'" style="width:405px;" maxlength="16" v-model="form.timeNumber"
              placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <!-- 按钮 -->
    <template #btns v-if="showBtn">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </template>
  </Dialogs>
</template>
<script>
import { updateZeroDetail, insertZeroDetail } from "@/api/api"
import Dialogs from "@/components/dialogs/dialogs.vue"

export default {
  props: ['dialog', 'handleClose', 'isView', 'formData'],
  data() {
    return {
      data: {
        size: 720,
        visible: true,
        title: "新增",
      },
      loading: false,
      close: function () { },
      showBtn: false,
      // 提交表单
      form: {
        date: "", // 日期
        peopleNumber: "", // 人数
        cost: "", // 费用
        timeNumber: "", // 次数
      },
      // 文件列表
      fileList: [],
      // 校验
      rules: {
        date: [{ required: true, message: "请选日期" }],
        peopleNumber: [{ required: true, message: "请填写人数" }],
        cost: [{ required: true, message: "请填写费用" }],
        timeNumber: [{ required: true, message: "请填写次数" }],
      },
      pickerOptions3: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.startDate);
          const end = Date.parse(this.form.endDate);
          if (this.form.endDate) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptions4: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.startDate);
          const end = Date.parse(this.form.endDate);
          if (this.form.startDate) {
            return (
              time.getTime() < start - 1000 * 60 * 60 * 24
            );
          } else {
            // return time.getTime() > Date.now();
          }
        },
      },
    }
  },
  methods: {
    // 提交
    async submitForm() {
      let bol = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          bol = false;
          return false;
        }
      });
      if (bol) {
        if (this.data.title == '新增') {
          const res = await insertZeroDetail(this.form)
          if (res.data.code == 200) {
            this.data.visible = false
            this.$parent.getList()
            this.$message.success(res.data.message);
            this.fileId = []
            this.fileList = []
            this.files = []
          } else this.$message.error(res.data.message);
        } else if (this.data.title == '修改') {
          const res = await updateZeroDetail(this.form)
          if (res.data.code == 200) {
            this.data.visible = false
            this.$parent.getList()
            this.$message.success(res.data.message);
            this.fileId = []
            this.fileList = []
            this.files = []
          } else this.$message.error(res.data.message);
        }
      }
    },
  },
  components: {
    Dialogs,
  },
  watch: {
    dialog: {
      handler(val) {
        this.$set(this, 'data', val)
      },
      immediate: true
    },
    handleClose: {
      handler(val) {
        this.$set(this, 'close', val)
      },
      immediate: true
    },
    isView: {
      handler(val) {
        this.$set(this, 'showBtn', val)
      },
      immediate: true
    },
    formData: {
      handler(val) {
        this.$set(this, 'form', val)
        this.$nextTick(() => {
          if (this.$refs.form)
            this.$refs.form.clearValidate();
        })
      },
    },

  }
}
</script>
<style scoped>
::v-deep .inlinitem.el-form-item {
  display: inline-flex;
  justify-content: flex-start;
}

::v-deep .inlinitem.el-form-item .el-form-item__content {
  margin-left: 2px !important;
}

.h120 {
  height: 120px;
}

::v-deep .h120 .el-textarea__inner {
  height: 120px;
}
</style>